/**
 * Contrôle d'un numéro SIRET saisi à la main (inscription pro, onglet « Entreprise française »,
 * entreprise absente de l'annuaire). Testé dans tests/siret.test.mjs.
 */

/** SIRET valide → ses 14 chiffres ; sinon null. Clé de Luhn, sauf La Poste (somme divisible par 5). */
export function siret(texte) {
  const n = String(texte ?? '').replace(/[\s.]/g, '')
  if (!/^\d{14}$/.test(n)) return null
  const chiffres = [...n].map(Number)
  if (n.startsWith('356000000')) return chiffres.reduce((a, b) => a + b, 0) % 5 === 0 ? n : null
  const somme = chiffres.reduce((total, c, i) => {
    const d = i % 2 === 0 ? c * 2 : c
    return total + (d > 9 ? d - 9 : d)
  }, 0)
  return somme % 10 === 0 ? n : null
}

if (typeof window !== 'undefined') window.MmSiret = { siret }
